(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afg-afterdark-hero"] && !Shopify.designMode) return;
  try {
    
function setupAfterDarkSwipe(root = document) {
  root.querySelectorAll('.ad-stock-hero').forEach(hero => {
    if (hero.dataset.swipeReady) return;
    hero.dataset.swipeReady = 'true';
    const track = hero.querySelector('.ad-stock-colors');
    const slides = [...track.children];
    const buttons = [...hero.querySelectorAll('[data-ad-slide]')];
    const sync = () => {
      const edge = track.getBoundingClientRect().left;
      let active = 0;
      slides.forEach((slide, index) => {
        if (Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(slides[active].getBoundingClientRect().left - edge)) active = index;
      });
      buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
      const link = slides[active].querySelector('a.ad-stock-product');
      const purchase = document.querySelector('#afg-collection-option');
      if (link && purchase) {
        const variant = new URL(link.href).searchParams.get('variant');
        if (purchase.value !== variant && [...purchase.options].some(option => option.value === variant)) {
          purchase.value = variant;
          purchase.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
    };
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      const left = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    track.addEventListener('scroll', sync, {passive: true});
  });
}
setupAfterDarkSwipe();
document.addEventListener('shopify:section:load', event => setupAfterDarkSwipe(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afg-atelier"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
if(root.dataset.ready)return;root.dataset.ready='true';
var tabs=Array.from(root.querySelectorAll('[data-afg-pick]'));var panels=Array.from(root.querySelectorAll('[data-afg-panel]'));
function choose(tab,focus){tabs.forEach(function(t){var active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});panels.forEach(function(p){p.hidden=p.dataset.afgPanel!==tab.dataset.afgPick;});if(focus)tab.focus();}
tabs.forEach(function(tab,index){tab.addEventListener('click',function(){choose(tab,false);if(typeof window.clarity==='function')window.clarity('event','campaign_product_choice');});tab.addEventListener('keydown',function(e){var next=index;if(e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();choose(tabs[next],true);});});if(tabs.length)choose(tabs[0],false);
root.querySelectorAll('[data-afga-product]').forEach(function(card){
var select=card.querySelector('[data-afga-variant]'),price=card.querySelector('[data-afga-price]'),img=card.querySelector('.afga-product-image'),composition=card.querySelector('[data-afga-composition]');
if(select)select.addEventListener('change',function(){card.querySelectorAll('[data-afga-option]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.afgaOption===select.value));});var mediaCaption=card.querySelector('[data-afga-media-caption]');if(mediaCaption)mediaCaption.hidden=true;var o=select.selectedOptions[0];if(price)price.textContent=o.dataset.price;if(card.classList.contains('afga-card--featured')){var variantUrl=new URL(window.location.href);variantUrl.searchParams.set('variant',select.value);window.history.replaceState(null,'',variantUrl);var stickyPrice=root.querySelector('[data-afga-sticky-price]');if(stickyPrice)stickyPrice.textContent=o.dataset.price;var stickyLabel=root.querySelector('[data-afga-sticky-label]');if(stickyLabel&&select.options.length>1)stickyLabel.textContent=o.textContent.trim();}if(img&&o.dataset.image){img.removeAttribute('srcset');img.src=o.dataset.image;if(o.dataset.image.includes('width=1100'))img.srcset=[320,550,800,1100].map(function(w){return o.dataset.image.replace('width=1100','width='+w)+' '+w+'w';}).join(',');var primary=card.querySelector('[data-afga-primary]');if(primary){primary.dataset.afgaPhoto=o.dataset.image;primary.querySelector('img').src=o.dataset.image;card.querySelectorAll('[data-afga-photo]').forEach(function(b){b.setAttribute('aria-pressed',String(b===primary));});}}if(typeof window.clarity==='function')window.clarity('event','atelier_variant_selected');});
card.querySelectorAll('[data-afga-option]').forEach(function(button){button.addEventListener('click',function(){select.value=button.dataset.afgaOption;select.dispatchEvent(new Event('change',{bubbles:true}));});});
card.querySelectorAll('[data-afga-photo]').forEach(function(button){button.addEventListener('click',function(){var caption=card.querySelector('[data-afga-media-caption]');if(caption){caption.textContent=button.dataset.afgaCaption||'';caption.hidden=!button.dataset.afgaCaption;}var showComposition=button.hasAttribute('data-afga-composite-thumb');if(composition){composition.hidden=!showComposition;img.hidden=showComposition;}if(!showComposition){img.removeAttribute('srcset');img.src=button.dataset.afgaPhoto;}card.querySelectorAll('[data-afga-photo]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});});});
var zoom=card.querySelector('[data-afga-zoom]'),dialog=root.querySelector('.afga-lightbox');
if(zoom&&dialog){zoom.addEventListener('click',function(){if(Number(card.dataset.swipedUntil||0)>Date.now())return;var content=dialog.querySelector('[data-afga-lightbox-content]');content.replaceChildren((composition&&!composition.hidden?composition:img).cloneNode(true));var mediaNote=card.querySelector('[data-afga-media-caption]');if(mediaNote&&!mediaNote.hidden)content.append(mediaNote.cloneNode(true));dialog.showModal();});}
if(zoom&&img){img.draggable=false;var startX=0,startY=0;zoom.addEventListener('pointerdown',function(e){startX=e.clientX;startY=e.clientY;});zoom.addEventListener('pointerup',function(e){var dx=e.clientX-startX,dy=e.clientY-startY;if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy))return;var photos=Array.from(card.querySelectorAll('[data-afga-photo]'));if(photos.length<2)return;var current=photos.findIndex(function(b){return b.getAttribute('aria-pressed')==='true';});var next=(Math.max(current,0)+(dx<0?1:-1)+photos.length)%photos.length;card.dataset.swipedUntil=String(Date.now()+500);photos[next].click();photos[next].scrollIntoView({block:'nearest',inline:'nearest'});});}
var form=card.querySelector('form');
if(form)form.addEventListener('submit',function(event){if(form.dataset.submitting){event.preventDefault();return;}form.dataset.submitting='true';var btn=form.querySelector('button[type="submit"]');if(btn){btn.textContent=root.dataset.adding;btn.setAttribute('aria-busy','true');}if(typeof window.clarity==='function')window.clarity('event','atelier_add_to_bag');});
});
var lightbox=root.querySelector('.afga-lightbox');if(lightbox){lightbox.querySelector('[data-afga-close]').addEventListener('click',function(){lightbox.close();});lightbox.addEventListener('click',function(e){if(e.target===lightbox)lightbox.close();});}
var sticky=root.querySelector('.afga-sticky'),isProduct=root.classList.contains('afga--product'),hero=isProduct?root.querySelector('.afga-form button[type="submit"]'):root.querySelector('.afga-hero__actions .afga-button');
if(sticky&&hero&&'IntersectionObserver' in window){var primaryVisible=true,shopVisible=false;function updateSticky(){sticky.hidden=primaryVisible||shopVisible;}new IntersectionObserver(function(entries){primaryVisible=entries[0].isIntersecting||entries[0].boundingClientRect.top>=0;updateSticky();},{threshold:0,rootMargin:'0px'}).observe(hero);var shopping=root.querySelector('.afga-shop');if(shopping&&!isProduct)new IntersectionObserver(function(entries){shopVisible=entries[0].isIntersecting;updateSticky();},{threshold:0}).observe(shopping);}
function previewOffset(){var bar=document.getElementById('PBarNextFrameWrapper');var r=bar?bar.getBoundingClientRect():null;root.style.setProperty('--afga-preview-offset',r&&r.width>200&&r.height<150?Math.ceil(r.height)+'px':'0px');}
previewOffset();window.addEventListener('resize',previewOffset);if('ResizeObserver' in window){var previewObserver=new ResizeObserver(previewOffset);previewObserver.observe(document.body);var previewBar=document.getElementById('PBarNextFrameWrapper');if(previewBar)previewObserver.observe(previewBar);}
var help=root.querySelector('[data-afga-chat]');if(help)help.addEventListener('click',function(){var chat=document.querySelector('shopify-chat');var shell=chat&&chat.shadowRoot;var runtime=shell&&shell.querySelector("shopify-agent-runtime");var trigger=shell&&shell.querySelector('button[part="activator"]');if(!trigger&&runtime&&runtime.shadowRoot)trigger=runtime.shadowRoot.querySelector('button[part="activator"]');if(trigger)trigger.click();});
if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){if(typeof window.clarity==='function')window.clarity('event','atelier_view_'+e.target.dataset.afgaObserve);observer.unobserve(e.target);}});},{threshold:.15});root.querySelectorAll('[data-afga-observe]').forEach(function(el){observer.observe(el);});}
root.querySelectorAll('[data-afga-track]').forEach(function(el){el.addEventListener('click',function(){if(typeof window.clarity==='function')window.clarity('event','atelier_'+el.dataset.afgaTrack);});});
}
document.querySelectorAll('[data-afga]').forEach(init);
window.addEventListener('pageshow',function(e){if(!e.persisted)return;document.querySelectorAll('[data-afga] form[data-submitting]').forEach(function(form){delete form.dataset.submitting;var b=form.querySelector('button[type="submit"]');if(b){b.textContent=form.closest('[data-afga]').dataset.addLabel;b.removeAttribute('aria-busy');}});});
document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-afga]').forEach(init);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
